import React, { FC } from 'react';
import { PageHeader as AntPageHeader } from 'antd';
import styled from 'styled-components';
import { PageHeaderProps } from 'antd/lib/page-header';

type Props = PageHeaderProps;

const PageHeader: FC<Props> = props => {
  return <StyledAntPageHeader {...props} />;
};

export default PageHeader;

const StyledAntPageHeader = styled(AntPageHeader)`
  .ant-page-header-heading {
    height: 42px;
  }

  .ant-page-header-heading-extra {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
